'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z' });

var BluetoothDisabled = function BluetoothDisabled(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

BluetoothDisabled = (0, _pure2.default)(BluetoothDisabled);
BluetoothDisabled.muiName = 'SvgIcon';

exports.default = BluetoothDisabled;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/BluetoothDisabled.js
// module id = 2172
// module chunks = 0